

import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { EleWorkTypeDDLAPI, WorkTypeDDLAPI } from '../../Redux/DDLSlice'
import { AstricSign } from '../../Helper/AstricSign'

export const ElEWorkTypeDDL = (props) => {
    const { WorkType, setWorkType, rowData, Flag, IsPost, IsDisabled, ApiFlag, ActiveBtn, isDisplay } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            Flag: ApiFlag,
            M_UserID: UserID,
            token: token
        }
        dispatch(EleWorkTypeDDLAPI({ data }))
    }, [IsPost && IsPost])

    const { WorkTypeData } = useSelector(state => state.EleWorkTypeDDLData)


    useEffect(() => {
        handleWorkTypeDDL()
    }, [WorkTypeData])

    const handleWorkTypeDDL = () => {
        if (WorkTypeData && WorkTypeData.table && WorkTypeData.table.length > 0) {
            let list = WorkTypeData.table.map((item, index) => ({
                value: item.m_eleC_WorkTypeID,
                label: item.workTypeName,
            }))

            setWorkType({
                DDL: list,
                ID: Flag === 'Update' ? rowData?.m_eleC_WorkTypeID : 0,
                Label: Flag === 'Update' ? rowData?.workTypeName : "Select ...",
            })

        }
        else {
            setWorkType({
                DDL: [],
                ID: 0,
                Label: "Select ...",
            })
        }

    }

    return (
        <div className="form-group">
            {
                (isDisplay && isDisplay == true) &&
                <label className="d-block" htmlFor="NameofWorkType"><b>Work Type {Flag && <AstricSign />} </b></label>
            }
            <Select
                isClearable
                // isRtl={isRtl}
                isDisabled={Flag === 'Update' && IsDisabled ? true : false}
                className=""
                isSearchable
                maxMenuHeight={115}
                value={{ value: WorkType.ID, label: WorkType.Label }}
                onChange={(e) => {
                    e ?
                        setWorkType({ ...WorkType, ID: e.value, Label: e.label })
                        :
                        setWorkType({ ...WorkType, ID: 0, Label: "Select WorkType" })
                }}
                options={WorkType.DDL}
            />
        </div>
    )
}